import React from "react";
import PicturesShell from "../PicturesShell";
import "./style.css";

export default function CameraAccessScreen({
  reason = "insecure",
  onRetry,
}) {
  const isInsecure = reason === "insecure";

  return (
    <PicturesShell
      mainClassName="pi-pictures-main--center pi-pictures-main--status"
      badge="Camera access"
      showFooter={false}
    >
      <div className="pi-pictures-status-card pi-pictures-status-card--premium pi-camera-access">
        <span className="pi-pictures-label">Camera access</span>
        <div className="pi-camera-access__icon" aria-hidden>
          {isInsecure ? "🔒" : "📷"}
        </div>
        <h1>{isInsecure ? "Secure connection required" : "Camera could not start"}</h1>
        <p>
          {isInsecure
            ? "Mobile browsers only allow the camera on HTTPS or localhost. Open this link using https:// or test from the same device at http://localhost."
            : "Allow camera permission when prompted, then tap the button below to try again."}
        </p>
        {!isInsecure && onRetry ? (
          <button type="button" className="pi-camera-access__retry" onClick={onRetry}>
            Enable camera
          </button>
        ) : null}
      </div>
    </PicturesShell>
  );
}
